<template>
  <popup
    v-model="isShowAlert"
    style="background-color: transparent" >
    <div class="flex double_center contain">
      <div class="head ">
        <p class="title">60秒接通律师</p>
        <p class="text ljb-margin-top">一对一专业咨询</p>
      </div>
      <div class="box ">
        <p class="align-center pop-title">先咨询&nbsp;&nbsp;后付费</p>
        <p class="align-center pop-text">{{ text }}</p>
      </div>
      <ListStep
        :show-padding-top="true"
        :step-bar="stepBar"/>
      <normal-btn
        :big-btn="true"
        :btn-text="btnText"
        class="align-center btn"
        @btnClick="btnClick"/>
    </div>
    <div class="align-center">
      <img
        class="close align-center"
        src="@/assets/imgs/close-coupon.png"
        @click="close">
    </div>

  </popup>
</template>

<script>

import {Popup} from 'vant'
import ListStep from '@/components/list/ListStepNew'
import NormalBtn from '@/components/common/NormalBtn'
export default {
  name: 'PopupConsulting',
  components: { NormalBtn, ListStep, Popup },
  model: {
    prop: 'isShow',
    event: 'close'
  },
  props: {
    typeList: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      isShowAlert: false,
      stepBar: {
        src: 'https://cdn.51ljb.cn/ljb-step4.png',
        list: ['立即咨询', '等待回电', '满意付款', '评价订单'],
        IsSm: true
      },
      btnText: '立即咨询'
    }
  },
  watch: {
    isShow: function (newvalue) {
      this.isShowAlert = newvalue
    },
    isShowAlert: function (newValue) {
      if (newValue === false) {
        this.$emit('close', false)
      }
    }
  },
  mounted: function () {
  },
  created () {
  },
  methods: {
    btnClick () {
      this.$emit('btnClick')
    },
    close () {
      this.$emit('close', false)
    }
  }

}
</script>

<style scoped lang="scss">
  .contain {
    box-sizing: border-box;
    background: #fff;
    border-radius: $big-radius;
    width: 321px;
    color: white;
    overflow: hidden;
    padding-bottom: $padding;
    .head {
      box-sizing: border-box;
      width: 100%;
      height: 147px;
      background: url("https://cdn.51ljb.cn/ljb-pop_consulting_bg.png") top no-repeat;
      background-size: 321px 147px;
      padding: 15px 0;
      text-align: center;
      vertical-align: center;
      color: #fff;
      letter-spacing: 2px;
      .title {
        font-size: 32px;
      }
      .text {
        font-size: 24px;
      }
      @extend .ljb-flex-column;
      @extend .ljb-double-center;
    }
    .box {
      width: 100%;
      padding-top: 21px;
      padding-bottom: 3px;
      .item {
        padding: 6px 10px;
        background: #fff5df;
        color: $base-color;
        border-radius: 4px;
      }
    }
  }
  .btn{
    margin: 0 $padding;
  }
  .close{
    width: 30px;
    height: 30px;
    margin-top: 40px;
    text-align: center;
  }

.pop-title{
  font-size: 18px;
  line-height: 18px;
  @extend .ljb-title
}
.pop-text{
  margin-top: 12px;
  font-size: 12px;
  line-height: 12px;
  color: $price-color;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/consulting/PopupConsulting.vue